module.exports = __webpack_public_path__ + "img/GD.08e34161.svg";